<template lang="pug">
.container-camera.mb-4
  label.btn(:class='classButton', for='cameraComponent')
    span {{ labelButton }}
    Icon.ms-2(name='camera')
  input#cameraComponent.d-none(
    type='file',
    name='image',
    accept='image/*',
    capture='user',
    @change='$emit("addPhoto", $event.target.files)'
  )
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '../Atoms/Icon.vue'

  export default defineComponent({
    name: 'CameraComponent',
    components: {
      Icon,
    },
    props: {
      labelButton: {
        type: String,
      },
      classButton: {
        type: String,
      },
    },
  })
</script>
<style scoped></style>
